import {type FunctionalComponent, h} from '@stencil/core';


export interface ResultList {
   loading: boolean
    tabular: boolean
    resultLoadingSpinner: boolean
    mobileView: boolean
    resultList: CallableFunction
}

export const ResultList: FunctionalComponent<ResultList> = (props) => {

    const {loading, tabular, resultLoadingSpinner, mobileView, resultList} = props;


    return (
      (loading && !tabular)
        ? resultLoadingSpinner && (
          <div class="results-loading__container">
            <se-loading
              full-page={mobileView}
              loading={
                loading
              }
              class="results-loading__spinner-color"
            />
          </div>
        )
        : resultList()
    );
};
